export default __webpack_public_path__ + "img/angle-down-solid.svg";